import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { changeSignUpForm } from 'src/actions/timepoll'
import moment from 'moment'
import cn from 'classnames'

import styles from './event-list.scss'
class EventList extends Component {
  getDate = item => {
    const { starts_at, ends_at } = item
    if (!starts_at || !ends_at) {
      return ''
    }
    if (!ends_at) {
      return moment(starts_at).format('dddd, MMM Do, h:mm A')
    }

    return (
      moment(starts_at).format('dddd, MMM Do, h:mm A') +
      ' - ' +
      moment(ends_at).format('dddd, MMM Do, h:mm A')
    )
  }

  handleChangeEvent = item => {
    const { onChangeSignUpForm, signUpForm, onClose, type, onChange } = this.props
    if (type === 'create') {
      onChangeSignUpForm({ ...signUpForm, checkedEvent: item })
    } else {
      onChange({ type: 'event', value: item })
    }
    onClose()
  }

  render() {
    const { eventList, signUpForm } = this.props
    return (
      <ul className={styles['event-wrapper']}>
        <li className={styles['event-header']}>events i'm hosting</li>
        {eventList.map((item, index) => (
          <li
            className={cn(styles['event-item'], {
              [styles['event-item-checked']]: item.id === signUpForm.checkedEvent?.id
            })}
            key={index}
            onClick={() => this.handleChangeEvent(item)}
          >
            <div className={styles['event-name']}>{item.name}</div>
            <div className={styles['event-time']}>{this.getDate(item)}</div>
          </li>
        ))}
      </ul>
    )
  }
}

EventList.defaultProps = {
  type: 'create'
}

EventList.propTypes = {
  eventList: PropTypes.array,
  onChangeSignUpForm: PropTypes.func,
  signUpForm: PropTypes.object,
  onClose: PropTypes.func,
  type: PropTypes.string,
  onChange: PropTypes.func
}

function mapStateToProps(state) {
  return {
    signUpForm: state.frontend.signUpForm
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onChangeSignUpForm: params => dispatch(changeSignUpForm(params))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventList)



// WEBPACK FOOTER //
// ./src/containers/time-poll/TimePollContainer/SignUp/CreateSignUp/FirstStep/EventList/EventList.jsx